import { ENABLE_TEAMS_INTEGRATION, isFeatureEnabled } from '/b2b/common/helpers/FeatureFlags';

import Component from './NotificationDeliveryPreferences.component';
import { PERMISSIONS } from '/b2b/authentication/constants';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';

const mapStateToProps = state => {
    // One plan entitlement (chatIntegration, toggled per account in Dash) governs
    // every chat channel. Teams stays behind its feature flag on top of the
    // entitlement until it ships; Slack is entitlement-only.
    const chatIntegrationEnabled = fromState.Auth.customer.getCanUseChatIntegration(state);

    return {
        canManageWorkspace: fromState.Auth.user.hasPermission(state, {
            toPerform: 'write',
            on: PERMISSIONS.INTEGRATIONS,
        }),
        slackIntegrationEnabled: chatIntegrationEnabled,
        teamsIntegrationEnabled:
            chatIntegrationEnabled && isFeatureEnabled(state, ENABLE_TEAMS_INTEGRATION),
    };
};

export default connect(mapStateToProps)(Component);
